var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorthernCyprus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87151 5.57593C3.31007 6.22799 2.80038 6.92568 2.34863 7.66287H29.6519C29.2001 6.92568 28.6905 6.22793 28.129 5.57593H3.87151Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87151 26.4456H28.1291C28.6905 25.7935 29.2002 25.0958 29.6519 24.3586H2.34869C2.80038 25.0958 3.31007 25.7935 3.87151 26.4456Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9528 13.085L15.2656 14.894L17.3916 14.2046L16.0768 16.0121L17.3894 17.8211L15.2641 17.1291L13.9493 18.9366L13.9506 16.7016L11.8253 16.0096L13.9514 15.3202L13.9528 13.085Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3697 20.5326C7.87249 20.5326 5.84799 18.5081 5.84799 16.0108C5.84799 13.5136 7.87249 11.4891 10.3697 11.4891C11.1484 11.4891 11.8811 11.6859 12.5207 12.0326C11.5172 11.0512 10.1449 10.4456 8.63062 10.4456C5.55699 10.4456 3.06543 12.9372 3.06543 16.0107C3.06543 19.0843 5.55705 21.5759 8.63062 21.5759C10.1449 21.5759 11.5172 20.9702 12.5207 19.9889C11.8811 20.3357 11.1484 20.5326 10.3697 20.5326Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNorthernCyprus);
export default __webpack_public_path__ + "static/media/flag_northern_cyprus.5cdf58f590c8f247836faa4f2ab1994e.svg";
export { ForwardRef as ReactComponent };